import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { Container, Button } from 'react-bootstrap';
import './Styles.css';
import { Spinner } from 'react-bootstrap';

import { useAgentDetails } from '../utils/useAgentDetails';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperPlane, faCheck } from '@fortawesome/free-solid-svg-icons';
import { FaHandshake } from 'react-icons/fa';
import AgentAuthorRow from '../components/AgentAuthorRow';
import EnquiryModal from '../components/EnquiryModal';

function EnquiryPage() {
  const { agent_slug, agentDetails, setAgentDetails, branding } = useAgentDetails();
  const [showEnquiry, setShowEnquiry] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1200);

  const location = useLocation();

  const { accentColor, buttonTextColor, isLight, iconColor, iconBgColor } = branding || {};

  useEffect(() => {
    if (agentDetails) {
      document.title = `${agentDetails.agency_name_short} — Free Property Consultation`;
    }
  }, [agentDetails]);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 1200);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  if (!agentDetails) {
    return (
      <div style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
      }}>
        <Spinner animation="border" />
      </div>
    );
  }

  return (
    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
      <div style={{
        position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, zIndex: 0,
        background: 'linear-gradient(180deg, #f8fafc 0%, #eef2f7 100%)',
      }} />

      <Container style={{ maxWidth: 560, position: 'relative', zIndex: 2 }}>
        <AgentAuthorRow agentDetails={agentDetails} showDivider={true} showContactButton={false} />

        <div style={{ textAlign: 'center', marginBottom: 32, marginTop: 8 }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 12, marginBottom: 8 }}>
            <div style={{
              width: 48, height: 48, borderRadius: 14,
              backgroundColor: `${iconBgColor}14`,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              flexShrink: 0,
            }}>
              <FaHandshake size={22} style={{ color: iconColor }} />
            </div>
            <h1 style={{
              fontSize: '1.6rem', fontWeight: 700, color: '#111',
              margin: 0, letterSpacing: '-0.02em',
            }}>
              Free Consultation
            </h1>
          </div>
        </div>

        <div style={{
          backgroundColor: '#fff',
          borderRadius: 16,
          boxShadow: '0 8px 28px rgba(15, 23, 42, 0.08), 0 2px 6px rgba(15, 23, 42, 0.04)',
          border: '1px solid rgba(15, 23, 42, 0.06)',
          padding: '28px 28px',
        }}>
          <ul style={{ listStyle: 'none', padding: 0, margin: '0 0 20px 0' }}>
            {[
              'No visit required — get a remote estimate',
              'Looking to sell your property',
              'Leasing your property',
              'Understanding your property\'s current value',
              'Need help understanding the market',
              'Obligation-free advice from a local expert',
            ].map((item, i) => (
              <li key={i} style={{ marginBottom: 10, fontSize: '0.9rem', color: '#374151', display: 'flex', alignItems: 'center' }}>
                <FontAwesomeIcon icon={faCheck} style={{ color: iconColor, marginRight: 10, flexShrink: 0 }} />
                {item}
              </li>
            ))}
          </ul>

          <Button
            onClick={() => setShowEnquiry(true)}
            style={{
              width: '100%',
              backgroundColor: accentColor,
              borderColor: isLight ? '#222' : accentColor,
              color: buttonTextColor,
              borderRadius: 12,
              padding: '14px 0',
              fontWeight: 600,
              fontSize: '0.95rem',
              boxShadow: `0 4px 16px ${accentColor}30`,
              transition: 'opacity 0.15s',
            }}
            onMouseEnter={e => e.currentTarget.style.opacity = '0.9'}
            onMouseLeave={e => e.currentTarget.style.opacity = '1'}
          >
            <FontAwesomeIcon icon={faPaperPlane} style={{ marginRight: 8 }} />
            Get In Touch
          </Button>
        </div>
      </Container>
      <EnquiryModal
        show={showEnquiry}
        onHide={() => setShowEnquiry(false)}
        agentDetails={agentDetails}
      />
    </div>
  );
}

export default EnquiryPage;